module.exports = __webpack_public_path__ + "media/images/details__prizeBox__stretch__first-3bdc3332bbacf28ef902bd960afd691f.png";